import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { BsModalRef, BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
import { BaseClass } from 'src/app/@shared/base-class/base-class';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';
import { MessageService } from 'src/app/@shared/message/message.service';
import { CommonService } from 'src/app/@shared/services/common.service';
import { PusherService } from 'src/app/@shared/services/pusher.service';
import { SharedService } from 'src/app/@shared/services/shared.service';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';
import { LoginComponent } from 'src/app/auth/login/login.component';
import { RulesPageComponent } from 'src/app/pages/rules-page/rules-page.component';
import Swal from "sweetalert2";

@Component({
  selector: 'app-topnav',
  templateUrl: './topnav.component.html',
  styleUrls: ['./topnav.component.css']
})
export class TopnavComponent extends BaseClass<any> implements OnInit {
  bsModalRef!: BsModalRef;
  public _pusher!: PusherService;
  public balInfo: any = {
    wall_amt: 0,
    net_expo: 0,
    bous: 0,
    avail_withdrawal: 0,
    await_bonus: 0
  }
  @ViewChild('afterLoginModal', { static: false }) afterLoginModal?: ModalDirective;
  openafterLoginModal = false;


  public currentDateTime = moment().format('YYYY/MM/DD, hh:mm:ss');
  constructor(
    public service: WebserviceService,
    public router: Router,
    public actRoute: ActivatedRoute,
    public _shared: SharedService,
    private injector: Injector,
    public _common: CommonService,
    public _message: MessageService) {
    super(document);
    
    this.setBalanceInfo();
    
    setInterval(() => {
      this.currentDateTime = moment().format('YYYY/MM/DD, hh:mm:ss');
    }, 1);

    this._shared.sharedLogin.subscribe(data => {
      if (data)
        this.showAfterLoginModal();
        // console.log("_shared.sharedLogin");
    });

    if (this.isLogin()) {
      this._pusher = injector.get<PusherService>(PusherService);
      this._pusher.userAccUpdate().subscribe(res => {
        if (res) {
          if (res.msg != '') {
            this._message.errmessage(res.msg);
            setTimeout(() => {
              this.removeLocalStorage();
              // this.router.navigate(['/login']);
              this.router.navigate(['/home']);
              setTimeout(() => {
                window.location.reload();
              }, 500)
            }, 1000)
          }
          if (res?.op == 'R') {
            this._shared.emitUpdateUserAccPusher(res);
          }
          this.setUserData(res);
          this.setBalanceInfo();
        }
      });
    }

    this.checkRedirectedFromSignup();

  }

  ngOnInit(): void {
    this.getMenu();
  }

  setBalanceInfo() {
    if (this.userData != null) {
      this.balInfo.wall_amt = this.decimalFixed(parseFloat(this.userData?.balance) + parseFloat(this.userData?.expose) + parseFloat(this.userData?.pl));
      this.balInfo.net_expo = this.decimalFixed(this.userData?.expose);
      this.balInfo.bonus = (this.userData?.pl < 0)
        ? this.decimalFixed(parseFloat(this.userData?.balance) + parseFloat(this.userData?.pl))
        : this.decimalFixed(this.userData?.balance);
      this.balInfo.avail_withdrawal = (this.userData?.pl < 0)
        ? 0.00
        : this.decimalFixed(parseFloat(this.userData?.expose) + parseFloat(this.userData?.pl));
      this.balInfo.await_bonus = this.userData?.bonus_amount ? this.userData?.bonus_amount : 0;
    }
  }

  checkRedirectedFromSignup() {
    this.actRoute.queryParams.subscribe(params => {
      if (params['login']) {
        this._common.goToLogin();
      }
    });

  }

  getServices(): IbaseService<any> {
    return this.service;
  }

  openLogin() {
    this._common.goToLogin();
  }

  openForgotPassword() {
    this._common.openModalWithComponent({ forgot: true }, LoginComponent, 'login-modal')
  }
  openBonusRule() {
    this._common.openModalWithComponent({ bonus: true }, RulesPageComponent, 'bonus-modal')
  }

  sportsbook(e: any) {
    if (!this.isLogin()) {
      this._common.goToLogin();
    } else {
      let msg = `<span style="color: #ff0000a3;"> <b>Please note(1 Point = 100 Points) <br> कृपया ध्यान दें(1 अंक = 100 अंक) </b></span><br> Profit & Loss in sports book would be 100 times.It means, if you WIN 1, your Account Statement would be Credited as 100 and similarly if you LOSE 1, your Account Statement would be Debited as 100.`;
      Swal.fire({
        title: 'DO YOU AGREE?',
        html: msg,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, I Agree',
        cancelButtonText: 'No, I dont Agree'
      }).then((result) => {
        if (result.value) {
          this.router.navigate(['/sports_book'])
        } else if (result.dismiss === Swal.DismissReason.cancel) {
        }
      })
    }
  }

  redirect() {
    this.router.navigate(['/exchange_sports/4'])
  }

  logOut() {
    this.getServices().Get(`${this.env.baseUrl + this.api.logout}`).subscribe(
      (res) => {
        this.removeLocalStorage();
        this.router.navigate(['/home']);
        this._message.succmessage(res.message);
        setTimeout(() => {
          window.location.reload();
        }, 1000)
        // window.location.reload();
      },
      (err) => {
        console.log(err);
      });
  }

  getMenu() {
    this.getServices().Get(`${this.env.baseUrl + this.api.menu}`).subscribe(
      (res) => {
        if (res.status == true) {
          if (!localStorage.getItem(`${this.env.panel}stakes`)) {
            localStorage.removeItem(`${this.env.panel}stakes`);
            localStorage.setItem(`${this.env.panel}stakes`, JSON.stringify(this.env.stakes));
          }

          let mn = this.changeInGameNamesMenu(res?.data?.menu);
          localStorage.removeItem(`${this.env.panel}menu`);
          localStorage.setItem(`${this.env.panel}menu`, JSON.stringify(mn));
          this._shared.emitSideMenu('');
        }
      },
      (err) => {
        console.log(err);
      });
  }

  public wpLink = '';
  getContactInfo() {
    this.userData = this.getLocalItem('user');
    if (this.userData?.branch_panel_active == 1) {
      let url = this.userData.contact_info.replace(':domain', this.env.host.domain);
      // let url = `https://reddypanel.com/contact/reddybook.club/358417/Jnq8MNgo9g5R2SCDf8d35db89cdcdfc9d975bd67e0309d22`; //testURL
      this.getServices().Get(url).subscribe(
        (res) => {
          if (res?.error == 0) {
            this.wpLink = res?.link;
          }
        },
        (err) => {
          console.log(err);
        });
    }
  }

  showAfterLoginModal() {
    if (localStorage.getItem(`${this.env.panel}popup`)) {
      // console.log("in");      
      this.afterLoginModal?.show();
      this.openafterLoginModal = true;
      localStorage.removeItem(`${this.env.panel}popup`);
    } else {
      // console.log('out');
      this.openafterLoginModal = false;
    }
  }

  isIn: boolean = false;
  ngDoCheck() {
    this.setBalanceInfo();
    this.env.trafficTag = this.router.url.includes('?') ? `?${this.router.url.split('?')[1]}` : '';

    if (this.isIn == false && this.isLogin()) {
      this.isIn = true;
      this.getContactInfo();
    }
  }

}
